export default __webpack_public_path__ + "static/media/employee.0e7e9354.svg";